import React from 'react';
import { Truck, Headphones, CheckCircle } from 'lucide-react';  // Import Lucide icons
import './styles/sub-footer.css';

const sub_footer = () => {
  return (
    <div className="features-container">
      <div className="features-content">
        <div className="sub_feature-item">
          <div className="icon-container">
            <div className="icon-background">
              <div className="icon-main">
                <Truck size={32} color="#ffffff" />
              </div>
            </div>
          </div>
          <div className="sub_feature-text">
            <div className="feature-title">FAST AND RELIABLE DELIVERY</div>
            <div className="feature-description">
              Reliable and fast delivery for all orders
            </div>
          </div>
        </div>

        <div className="sub_feature-item">
          <div className="icon-container">
            <div className="icon-background">
              <div className="icon-main">
                <Headphones size={32} color="#ffffff" />
              </div>
            </div>
          </div>
          <div className="sub_feature-text">
            <div className="feature-title">24/7 CUSTOMER SERVICE</div>
            <div className="feature-description">
              Friendly 24/7 customer support
            </div>
          </div>
        </div>

        <div className="sub_feature-item">
          <div className="icon-container">
            <div className="icon-background">
              <div className="icon-main">
                <CheckCircle size={32} color="#ffffff" />
              </div>
            </div>
          </div>
          <div className="sub_feature-text">
            <div className="feature-title">QUALITY GUARANTEE</div>
            <div className="feature-description">
            We are committed to your satisfaction
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default sub_footer;
